module.exports = __webpack_public_path__ + "assets/img/101902.79387047.png";